import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Fire_station_EXPO.webp';

const Project_eleven = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Fire & Ambulance Expo</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A specialised exhibition facility for the UAE's civil defence and emergency services sector, showcasing fire safety and
                ambulance technologies. A key platform for government emergency services procurement and capability display.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Transgulf</p>
              <p>GEMCO SCOPE OF WORKS : CHW works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_eleven